"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = exports.CircledVehicle = exports.Circle = void 0;

var StyledCircle = _interopRequireWildcard(require("./styled"));

exports.Styled = StyledCircle;

var utils = _interopRequireWildcard(require("../../../utils"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Circle = utils.makeRotatedMarker(utils.makeBasicVehicleShape(StyledCircle.Shape, StyledCircle.TrackedShape, zoom => {
  const midZoom = 12;
  const midSize = 13.0;
  const farSize = 7.0;
  return zoom >= midZoom ? midSize : farSize;
}));
exports.Circle = Circle;
const CircledVehicle = utils.makeRotatedMarker(({
  color,
  highlightColor,
  isTracked,
  routeType
}) => {
  return utils.makeVehicleIcon(StyledCircle, routeType, color, highlightColor, isTracked);
}); // Rename styled components for export

exports.CircledVehicle = CircledVehicle;
//# sourceMappingURL=index.js.map